import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import i18n, { loadTranslations } from 'i18n';
import { resetItinerariesItemDataAction, setItinerariesItemDataAction } from 'store/itinerariesItem';
import { buildItinerariesItemRoute } from 'store/itinerariesItem/thunks';
import { accountIdSelector } from 'store/user/selectors';
import axios from 'utils/axios';

export function useItinerariesItemLoader(itemType) {
  const { itemId } = useParams();
  const accountId = useSelector(accountIdSelector);
  const { isFetching, isError } = useQuery(
    [itemType, itemId],
    async ({ signal }) => {
      if (itemId !== '0') {
        return await axios.get(buildItinerariesItemRoute(accountId, itemId), { signal }).then(({ data }) => data);
      }

      return { type: itemType };
    },
    {
      refetchOnReconnect: false,
      onSuccess: async (data) => {
        await loadTranslations(i18n, data?.settings?.language);
        dispatch(setItinerariesItemDataAction(data));
      },
    },
  );
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetItinerariesItemDataAction());
    };
  }, [dispatch]);

  return { isFetching, isError };
}
